import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import Calculator from '../components/calculator/Calculator';
import {setCalculatorMode} from '../actions/actionsAppCalculator.js';
import {fetchOffersIfNeeded} from '../actions/actionsApiOffer.js';

export default function ContCalculator(props) {
  const globalstate = useContext(ReducerContext);
  const dispatch = useContext(ReducerDispatchContext);

  function onChangeMode(calculatorMode) {
    dispatch(setCalculatorMode(calculatorMode));
    fetchOffersIfNeeded({...globalstate, calculator:{...globalstate.calculator, calculatorMode:calculatorMode}}, dispatch, globalstate.responseSimulation.selectedVehicle, null);
  }

  return (
    <Calculator
      onUpdate={props.onUpdate}
      onChangeMode={onChangeMode}
      context={globalstate.testCriteria.context}
      settings={globalstate.settings}
      vehicle={globalstate.responseSimulation.selectedVehicle}
      calculatorMode={globalstate.calculator.calculatorMode}
      parameters={globalstate.calculator.parameters}
      customer={globalstate.calculator.customer}
      simulationDetails={globalstate.calculator.responseVehicleSimulationDetails && globalstate.calculator.responseVehicleSimulationDetails.vehicleDetails}
    />
  );
}
